<svelte:options accessors />

<script>
    export let value = "";
    export let placeholder = "";
    export let showToggle = true; // Enable toggle by default
    export let autocomplete = "on";
    export let name = "";
    //export let onToggle = null;
    //export let visible = undefined;
    export let onRequestShow = null;

    let inputRef;
    let isPasswordVisible = false;

    export function show() {
      isPasswordVisible = true;
    }

    //$: effectiveVisibility = visible !== undefined ? visible : isPasswordVisible;
    //$: usingExternalVisibility = visible !== undefined;
    //$: effectiveVisibility = usingExternalVisibility ? visible : isPasswordVisible;
  
    function togglePasswordVisibility() {
      if (isPasswordVisible) {
        isPasswordVisible = false;
      } else {
        if (onRequestShow) {
          onRequestShow(); 
        } else {
          isPasswordVisible = true;
        }
      }
    }
    
  </script>
  
  <div class="font-[Open\ Sans] w-full relative">

    {#if isPasswordVisible}
      <input
        type="text"
        placeholder={placeholder}
        autocomplete={autocomplete}
        name={name}
        class="w-full pr-10 bg-[var(--app-background-color)] text-[var(--app-text-color)] border border-[var(--app-alt-color)] rounded p-2 focus:outline-none"
        bind:value={value}
        bind:this={inputRef}
        on:input
      />
    {:else}
      <input
        type="password"
        placeholder={placeholder}
        autocomplete={autocomplete}
        name={name}
        class="w-full pr-10 bg-[var(--app-background-color)] text-[var(--app-text-color)] border border-[var(--app-alt-color)] rounded p-2 focus:outline-none"
        bind:value={value}
        bind:this={inputRef}
        on:input
      />
    {/if}
    
    {#if showToggle}
      <button
        type="button"
        class="absolute top-1/2 right-2 transform -translate-y-1/2 text-gray-300 hover:text-white focus:outline-none border-none bg-transparent"
        on:click={togglePasswordVisibility}
        aria-label="Toggle password visibility"
      >
        {#if isPasswordVisible}
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-.51 1.857-1.726 3.49-3.458 4.685a8.971 8.971 0 01-6.084 2.315 8.971 8.971 0 01-6.084-2.315C4.184 15.49 2.968 13.857 2.458 12z" />
          </svg>
        {:else}
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-.51 1.857-1.726 3.49-3.458 4.685a8.971 8.971 0 01-6.084 2.315 8.971 8.971 0 01-6.084-2.315C4.184 15.49 2.968 13.857 2.458 12z" />
            <line x1="4" y1="4" x2="20" y2="20" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        {/if}
      </button>
    {/if}
  </div>
  